import React from 'react';
import {FormattedMessage} from "react-intl";

export function getShippingMethodName(shippingMethod) {
    if (!shippingMethod) {
        return null;
    }

    return shippingMethod.name ?? (
        <FormattedMessage
            id={`picking.order.shippingMethod.${shippingMethod.shippingMethodShopName}`}
            defaultMessage={shippingMethod.name}
        />
    );
}
